import { createFileRoute, redirect } from '@tanstack/react-router';

import { createProject, projectQueries } from '@/lib/queries/project';

import { ProjectCreationPending } from './-pending';

export const Route = createFileRoute('/_root/new-project/')({
  component: ProjectCreationPending,
  loader: async ({ context: { toast, queryClient } }) => {
    const { defaultProject } = await queryClient.ensureQueryData(
      projectQueries.default(),
    );

    if (defaultProject !== undefined) {
      throw redirect({ to: '/' });
    }

    await createProject();
    await queryClient.invalidateQueries(projectQueries.default());

    toast({
      title: 'newProject.success',
    });

    throw redirect({ to: '/getting-started' });
  },
  pendingComponent: ProjectCreationPending,
});
